import {XauditModel} from '../../../models/xaudit.model';
import {TreatmentEndoPerforationDataModel} from './treatment-endo-perforation-data.model';
import {TreatmentEndoCanalDataModel} from './treatment-endo-canal-data.model';
import {DataPatientCaseWorkItemFormToothModel} from '../../../models/teeth/data-patient-case-work-item-form-tooth.model';
import {ToothConfigurationModel} from '../../../models/teeth/tooth-configuration.model';
import {DataPatientCaseWorkItemToothModel} from '../../../models/teeth/data-patient-case-work-item-tooth.model';

export class TreatmentEndoDataModel extends XauditModel {
  TreatmentID: string;
  PatientId: string;
  CaseWorkItemFormsId: string;
  CompleteDate: Date;
  AssistantUserID: string;

  enumEndoIrrigationProtocolID: string;
  enumEndoInstrumentProtocolID: string;
  enumEndoIrrigationVolumUsedID: string;
  enumEndoOcclusionReductionID: string;

  isFractures: boolean;
  isInterimReportSend: boolean;

  InterimReportSentOn: Date;
  InterimReportSentBy: string;

  enumEndoInterimReportFollowInID: string;
  enumEndoInterimReportExtTreatmentID: string;
  InterimReportDate: Date;

  enumEndoBleedingID: string;
  enumEndoIntraOperatoryPainID: string;
  enumEndoExistingRestorationID: string;
  enumEndoRequestedCoronalEndoID: string;
  RequestedCoronalOther: string;
  EndoTreatmentDateBy: Date;

  enumEndoClampID: string;
  enumEndoPretreatmentID: string;
  isEndoBiteBlock: boolean;
  enumEndoBiteBlock: string;
  isRequiredAnasthesia: boolean;
  isWasNotSinglVisitTreatment: boolean;
  isHadNaOClevent: boolean;
  isGentleWave: boolean;

  dataTreatmentEndoPerforations: TreatmentEndoPerforationDataModel[];
  dataTreatmentEndoCanals: TreatmentEndoCanalDataModel[];

  // CaseWorkItemTeeth, CaseWorkItemFormsTeeth, cfgTooth
  CaseWorkItemTeeth: DataPatientCaseWorkItemToothModel[];
  CaseWorkItemFormTeeth: DataPatientCaseWorkItemFormToothModel[];
  cfgTeeth: ToothConfigurationModel[];
}
